export default __webpack_public_path__ + "static/media/on-28.00188050.png";